/* 南方洋行 · 每单最多 6 件（LP、CD 合计），商品重量 1,800 g 以内（10/12 加件数）
   - 商品页：数量框下面的提示 [data-nh-room] 由 Liquid 按购物车现在的总重量算好（snippets/nanpo-weight-room.liquid）。
     加购、改变款式后 Dawn 会重新取这一段 HTML 换上去，这里跟着把加购按钮和快捷结账按钮关掉或打开。
     只打开自己关掉的按钮（data-nh-full），售罄等原因关掉的不动。
   - 购物车页：改数量后 Dawn 只重画商品行和小计，这里按返回的 total_weight 显示「最多 6 张」的红字，
     结账按钮变灰、快捷结账藏起来（snippets/nanpo-cart-limit.liquid、sections/main-cart-footer.liquid）。
   - 数量框手打的数超过上限（max）时改回上限：Dawn 只让加减按钮停在上限，手打的数照样能加进购物车。 */
(() => {
  const CAP = 1800, MAX_ITEMS = 6;
  const cartState = (weight, count) => {
    const over = weight > CAP || count > MAX_ITEMS;
    document.querySelectorAll('[data-nh-cart-limit]').forEach(p => { p.hidden = !over; });
    const btn = document.getElementById('checkout');
    if (btn) {
      if (over && !btn.disabled) { btn.disabled = true; btn.setAttribute('data-nh-full', ''); }
      else if (!over && btn.hasAttribute('data-nh-full')) { btn.disabled = false; btn.removeAttribute('data-nh-full'); }
    }
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(d => { d.hidden = over; });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, e => {
      const d = e && e.cartData;
      if (d && typeof d.total_weight === 'number') cartState(d.total_weight, typeof d.item_count === 'number' ? d.item_count : 0);
    });
  }

  const sync = () => {
    document.querySelectorAll('[data-nh-room]').forEach(note => {
      const form = document.getElementById(note.dataset.form);
      if (!form) return;
      const full = parseInt(note.dataset.nhRoom, 10) === 0;
      const btn = form.querySelector('[name="add"]');
      if (btn) {
        if (full && !btn.disabled) { btn.disabled = true; btn.setAttribute('data-nh-full', ''); }
        else if (!full && btn.hasAttribute('data-nh-full')) { btn.disabled = false; btn.removeAttribute('data-nh-full'); }
      }
      /* data-nh-away：只卖日本的商品、访客不在日本市场（snippets/nanpo-jp-away.liquid），一直不显示 */
      form.querySelectorAll('.nh-dyn').forEach(d => { d.hidden = full || d.hasAttribute('data-nh-away'); });
    });
  };
  const watch = () => {
    sync();
    document.querySelectorAll('.quantity__rules').forEach(el => new MutationObserver(sync).observe(el, { childList: true, subtree: true }));
  };
  /* 捕获阶段先于 Dawn 的 change 处理：超过 max 就改成 max */
  document.addEventListener('change', e => {
    const input = e.target;
    if (!input || !input.matches || !input.matches('.quantity__input[max]')) return;
    const max = parseInt(input.max, 10), v = parseInt(input.value, 10);
    if (max >= 0 && v > max) input.value = max;
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
